export type GuidebookUpsellType = 'waivo_damage_protection' | 'viator_affiliate' | 'custom_fee';

export type GuidebookUpsellPriceType = 'fixed' | 'per_night' | 'percentage';

export interface GuidebookUpsellConfig {
  id: number;
  guidebook_config_id: number;
  type: GuidebookUpsellType;
  name: string;
  description: string;
  enabled: boolean;
  price: number | null;
  price_type: GuidebookUpsellPriceType | null;
  is_optional: boolean;
  settings: Record<string, any>;
  created_at: string;
  updated_at: string;
}

export const BUILT_IN_UPSELLS: Partial<GuidebookUpsellConfig>[] = [
  {
    type: 'waivo_damage_protection',
    name: 'Waivo Damage Protection',
    description: 'Optional damage protection for guests. Covers accidental damage during their stay, replacing traditional security deposits.',
    enabled: false,
    price: null,
    price_type: null,
    is_optional: true,
    settings: {},
  },
  {
    type: 'viator_affiliate',
    name: 'Viator Experiences',
    description: 'Recommend local tours and experiences to your guests through the Viator affiliate program. Earn commission on bookings.',
    enabled: true,
    price: null,
    price_type: null,
    is_optional: true,
    settings: {
      affiliate_id: '',
    },
  },
];

export const COMMON_CUSTOM_FEE_TEMPLATES: { name: string; description: string; price_type: GuidebookUpsellPriceType }[] = [
  { name: 'Pet Fee', description: 'Fee for guests bringing pets to the property.', price_type: 'fixed' },
  { name: 'Early Check-In', description: 'Fee for checking in earlier than the standard time.', price_type: 'fixed' },
  { name: 'Late Check-Out', description: 'Fee for checking out later than the standard time.', price_type: 'fixed' },
  { name: 'Extra Guest Fee', description: 'Fee for each guest beyond the base occupancy.', price_type: 'per_night' },
  { name: 'Pool Heating', description: 'Fee for heating the pool during the stay.', price_type: 'per_night' },
  { name: 'Airport Transfer', description: 'Fee for airport pickup and drop-off service.', price_type: 'fixed' },
];
